module.exports = __webpack_public_path__ + "static/media/26.b3a372d5.jpg";